import { render, staticRenderFns } from "./ModalForm.vue?vue&type=template&id=0cdb6728&scoped=true&"
import script from "./ModalForm.vue?vue&type=script&lang=js&"
export * from "./ModalForm.vue?vue&type=script&lang=js&"
import style0 from "./ModalForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalForm.vue?vue&type=style&index=1&id=0cdb6728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdb6728",
  null
  
)

export default component.exports